<template>
    <div>
        <header class="main_header_arae">
            <!-- Top Bar -->
            <div class="topbar-area">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-6 col-md-6">
                            <ul class="topbar-list">
                                <li><i class="fas fa-map-marker-alt" style="color:#09B6AC;"></i> Aeropuerto Baltra, Galápagos Ecuador</li>
                                <li><a href="mailto:ventasgrupo@lobitogalapagos.com"><i class="fas fa-envelope" style="color:#09B6AC;"></i> <span>ventasgrupo@lobitogalapagos.com</span></a></li>
                            </ul>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <ul class="topbar-others-options">
                                <!-- <li><router-link to="/login">Login</router-link></li>
                                <li><router-link to="/register">Sign up</router-link></li> -->
                                <!-- <li>
                                    <div class="dropdown language-option" id="dropdown-btn" style="padding-right: 0px;">
                                        <img width="28" src="https://flagsapi.com/GB/shiny/64.png" class="locale-img" v-if="$i18n.locale ==='en'">
                                        <img width="28" src="https://flagsapi.com/ES/shiny/64.png" class="locale-img" v-else-if="$i18n.locale ==='es'">
                                        <select v-model="$i18n.locale" class="dropdown-content" @change="onLocaleChange" >
                                            <option value="en">English</option>
                                            <option value="es">Español</option>
                                        </select>
                                    </div>
                                </li> -->
                                <li>
                                    <a href="https://www.instagram.com/lobitogalapagos/" target="_blank"><i class="fab fa-instagram" style="color:#09B6AC; font-size:18px; margin-right:8px;"></i></a>
                                    <a href="https://www.facebook.com/LobitoEcu/" target="_blank"><i class="fab fa-facebook" style="color:#09B6AC; font-size:18px; margin-right:8px;"></i></a>
                                    <a href="https://api.whatsapp.com/send?phone=593967549023&text=Hello%20*Lobito*!%20I%20would%20like%20more%20information%20about..." target="_blank"><i class="fab fa-whatsapp" style="color:#09B6AC; font-size:18px; margin-right:5px;"></i></a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Navbar Bar -->
            <div class="navbar-area is-sticky" style="position: sticky!important;">
                <div class="main-responsive-nav">
                    <div class="container">
                        <div class="main-responsive-menu mean-container">
                            <nav class="navbar">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div class="logo">
                                        <a class="navbar-brand" href="https://lobitogalapagos.com/dev/">
                                            <img src="../assets/img/logo.png" alt="logo">
                                        </a>
                                    </div>
                                    <div class="dropdown language-option p-0" id="dropdown-btn">
                                        <img width="28" src="https://flagsapi.com/GB/shiny/64.png" class="locale-img" v-if="$i18n.locale ==='en'">
                                        <img width="28" src="https://flagsapi.com/ES/shiny/64.png" class="locale-img" v-else-if="$i18n.locale ==='es'">
                                        <select v-model="$i18n.locale" class="dropdown-content">
                                            <option value="en">English</option>
                                            <option value="es">Español</option>
                                        </select>
                                    </div>
                                    <button class="navbar-toggler collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#navbar-content">
                                        <div class="hamburger-toggle" style="height: 30px; width: 30px;">
                                            <div class="hamburger">
                                                <span></span>
                                                <span></span>
                                                <span></span>
                                            </div>
                                        </div>
                                    </button>
                                    <div class="collapse navbar-collapse mean-nav" id="navbar-content">
                                        <ul class="navbar-nav mr-auto mb-2 mb-lg-0">
                                            <li class="nav-item">
                                                <router-link to="/tour-details" class="nav-link" @click="closeNavbar">{{ $t('titles.shop') }}</router-link>
                                            </li>   
                                            <!-- <li class="nav-item">
                                                <router-link to="/checkout" class="nav-link" @click="closeNavbar">{{ $t('titles.checkout') }}</router-link>
                                            </li> -->
                                            <li class="nav-item">
                                                <router-link to="/card-balance" class="nav-link" @click="closeNavbar">{{ $t('titles.check_balance') }}</router-link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
                <div class="main-navbar">
                    <div class="container">
                        <nav class="navbar navbar-expand-md navbar-light">
                            <a class="navbar-brand" href="https://lobitogalapagos.com/dev/">
                                <img src="../assets/img/logo.png" alt="logo" width="186" height="63">
                            </a>    

                            <div class="collapse navbar-collapse mean-menu" id="navbarSupportedContent">
                                <ul class="navbar-nav">
                                    <!-- <li class="nav-item">
                                        <router-link to="/" class="nav-link">Home</router-link>
                                    </li> -->
                                    <li class="nav-item">
                                        <router-link to="/tour-details" class="nav-link" @click="closeNavbar" style="color:#09B6AC; font-weight: 500;">{{ $t('titles.shop') }}</router-link>
                                    </li>              
                                    <!-- <li class="nav-item">
                                        <router-link to="/checkout" class="nav-link" @click="closeNavbar">{{ $t('titles.checkout') }}</router-link>
                                    </li> -->
                                    <li class="nav-item">
                                        <router-link to="/card-balance" class="nav-link" @click="closeNavbar" style="color:#09B6AC; font-weight: 500;">{{ $t('titles.check_balance') }}</router-link>
                                    </li>
                                    <!-- <li class="nav-item">
                                        <router-link to="/contact" class="nav-link">Contact</router-link>
                                    </li>                                -->
                                </ul>

                                <div class="others-options d-flex align-items-center">
                                    <div class="dropdown language-option" id="dropdown-btn" style="padding-right: 0px;">
                                        <img width="28" src="https://flagsapi.com/GB/shiny/64.png" class="locale-img" v-if="$i18n.locale ==='en'">
                                        <img width="28" src="https://flagsapi.com/ES/shiny/64.png" class="locale-img" v-else-if="$i18n.locale ==='es'">
                                        <select v-model="$i18n.locale" class="dropdown-content" @change="onLocaleChange" >
                                            <option value="en">English</option>
                                            <option value="es">Español</option>
                                        </select>
                                    </div>
                                    <div class="option-item">                                   
                                        <router-link to="/checkout" class="btn  btn_navber">
                                            <i class="fa fa-shopping-cart"></i>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </nav>
                    </div>
                </div>
                <div class="others-option-for-responsive">
                    <div class="container">
                        <div class="container">
                            <div class="option-inner">
                                <div class="others-options d-flex align-items-center">
                                    <div class="option-item">
                                        <a href="#" class="search-box"><i class="fas fa-search"></i></a>
                                    </div>
                                    <div class="option-item">
                                        <router-link to="/contact" class="btn btn_navber">Get free quote</router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    </div>
</template>

<script>
import { setLocale } from '@vee-validate/i18n';
setLocale('ar');

export default {
    name: 'Header',
    data() {
        return {
            language: 'English',
            currency: 'USD',
            isSticky: false,
        }
    },

    methods: {
        getCart(){
            
        },
        onLocaleChange(event) {
            setLocale(event.target.value);
        },
        closeNavbar() {
            const navbar = document.getElementById('navbar-content');
            if (navbar.classList.contains('show')) {
                navbar.classList.remove('show'); // Bootstrap toggles 'show' to open/close
        }
}
    },

    mounted() {
        window.addEventListener('scroll', () => {
            let scroll = window.scrollY
            if (scroll >= 200) {
                this.isSticky = true
            } else {
                this.isSticky = false
            }
        })

        document.addEventListener('click', function (e) {
            // Hamburger menu
            if (e.target.classList.contains('hamburger-toggle')) {
                e.target.children[0].classList.toggle('active');
            }
        })

        this.getCart()
    }
}
</script>

<style>
    #dropdown-btn {
        min-width: 130px;
        width: max-content;
        border-radius: 5px;
        color: white;
        padding: 10px;
        font-size: 16px;
        border: none;
        cursor: pointer;
        justify-content: space-evenly;
    }
    .locale-img {
        margin: 0 5px 0 0;
    }
    .dropdown button img,
    .dropdown-content li img {
        width: 28px;
    }
</style>

